<template>
  <b-modal
    id="modalReview"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    hide-actions>
    <section class="c-modal-lection c-modal-lection--review">
      <div class="c-modal-lection__dialog">
        <div class="br--small overflow-hidden">
          <section
            class="c-success-message position-absolute w-100 h-100 p-3 p-lg-4"
            :class="{visible : review.sent}">
            <div class="d-flex flex-column justify-content-center align-items-center h-100">
              <h3 class="darks w-bold fs-25">Valoración enviada</h3>
              <p class="mb-4 mb-md-5 fs-18 w-medium">
                Muchas gracias por tu valoración, esto nos ayuda a
                mejorar constantemente y brindarte lo mejor
              </p>
              <figure class="c-success-message__vector mb-4">
                <img
                  class="w-100 h-100 of--contain"
                  src="../../../assets/images/lection/review/success.png"
                  alt=""
                />
              </figure>
              <button
                class="c-button c-button--primary-ghost small"
                @click="closeReviewModal()"
              >
                Cerrar mensaje
              </button>
            </div>
          </section>
          <section class="p-3 p-lg-4">
            <h3 class="fs-25 w-bold mb-4 darks text-center">¿Cómo calificas este curso?</h3>
            <form class="c-form c-form--ghost mb-4">
              <div
                class="c-reactions mb-3"
                :class="`rank${review.rank_temp ? review.rank_temp : review.rank.current}`"
              >
                <div class="c-reactions__walk">
                  <figure class="c-reactions__emoji">
                    <img
                      class="w-100 h-100 of--contain"
                      src="../../../assets/images/lection/review/reactions/rank1.png" alt=""
                    />
                  </figure>
                  <figure class="c-reactions__emoji">
                    <img
                      class="w-100 h-100 of--contain"
                      src="../../../assets/images/lection/review/reactions/rank2.png" alt=""
                    />
                  </figure>
                  <figure class="c-reactions__emoji">
                    <img
                      class="w-100 h-100 of--contain"
                      src="../../../assets/images/lection/review/reactions/rank3.png" alt=""
                    />
                  </figure>
                  <figure class="c-reactions__emoji">
                    <img
                      class="w-100 h-100 of--contain"
                      src="../../../assets/images/lection/review/reactions/rank4.png" alt=""
                    />
                  </figure>
                  <figure class="c-reactions__emoji">
                    <img
                      class="w-100 h-100 of--contain"
                      src="../../../assets/images/lection/review/reactions/rank5.png" alt=""
                    />
                  </figure>
                </div>
              </div>
              <div class="d-flex justify-content-center mb-3">
                <label
                  v-for="level of [1,2,3,4,5]"
                  @mouseover="updateRank(level, true)"
                  @mouseleave="updateRank(level, false)"
                  :key="level.id"
                  class="c-rank"
                  :class="(review.rank_temp >= level || review.rank.current >= level)
                    ? 'filled' : ''"
                >
                  <i class="iconf-star fs-21" />
                  <input
                    type="radio"
                    class="d-none"
                    :value="level"
                    v-model="review.rank.current"
                    @change="review.rank.last = level"
                  />
                </label>
              </div>
              <div class="row">
                <div class="col col-12">
                  <p class="c-form__label mb-1">Cuéntanos ¿Qué te pareció este curso?</p>
                  <textarea
                    class="c-form__textarea w-100"
                    placeholder="Escribe un comentario"
                    v-model="review.comment">
                  </textarea>
                </div>
              </div>
            </form>
            <div class="d-flex aligm-items-center justify-content-end">
              <button
                class="c-link c-link--black"
                :disabled="cancelCounter > 0"
                @click="closeReviewModal"
              >
                Cancelar
                <span v-if="cancelCounter > 0">({{cancelCounter}})</span>
              </button>
              <button
                class="c-button c-button--primary ms-3"
                :class="{ loading : review.isLoading }"
                @click="sendReview">
                {{(review.isLoading) ? 'Enviando...' : 'Enviar valoración'}}
                <img
                  class="c-button__spinner"
                  src="../../../assets/images/animations/spinner-white.png"
                  alt="loading"
                />
              </button>
            </div>
          </section>
        </div>
      </div>
    </section>
  </b-modal>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      review: {
        rank: {
          current: 5,
          last: 5,
        },
        rank_temp: 5,
        comment: '',
        isLoading: false,

        sent: false,
        loaded: false,
      },

      cancelCounter: 0,
      cancelCounterTimer: null,
    }
  },
  props: ['user', 'course', 'progress', 'playerProgress', 'curriculum'],
  computed: {
    hasOneLection() {
      return this.curriculum && this.curriculum.modules.length === 1 && this.curriculum.lessons.data.length === 1;
    },
  },
  watch: {
    progress() {
      this.showModalReview();
    },
    playerProgress(progress) {
      if (this.hasOneLection) {
        this.showModalFromProgress(progress.percent * 100);
      }
    },
    'review.loaded': function reviewLoaded() {
      this.showModalReview();
    },

    cancelCounter(value) {
      if (value === 0) {
        window.clearInterval(this.cancelCounterTimer);
      }
    },
  },
  mounted() {
    this.removeReviewsStorage();

    this.getRating();
  },
  methods: {
    updateRank: function(level, state){
      if (state) {
        this.review.rank_temp = level;

        if(this.review.rank.current) {
          this.review.rank.last = this.review.rank.current;
          this.review.rank.current = 0;
        }
      } else {
        this.review.rank.current = this.review.rank.last;
        this.review.rank_temp = 0;
      }
    },
    closeReviewModal: function() {
      this.$bvModal.hide('modalReview');
    },
    getRating: function() {
      const requestURL = `${window.arcux.site}/api/v1/users/${this.user.id}/ratings/?courseId=${this.course}`;

      fetch(requestURL, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        this.review.sent = true;

        this.$emit('fill-rating-star');
      })
      .catch(err => {
        throw err;
      })
      .finally(() => {
        this.review.loaded = true;
      })
    },
    sendReview: function() {
      this.review.isLoading = true;

      const requestURL = `${window.arcux.site}/api/v1/users/${this.user.id}/ratings/`;

      let formData = new FormData()

      formData.append('userId', this.user.id);
      formData.append('courseId', this.course);
      formData.append('message', this.review.comment);
      formData.append('value', this.review.rank.last);

      fetch(requestURL,{
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        this.review.isLoading = false;
        this.review.sent = true;

        this.removeReviewsStorage();

        this.$emit('fill-rating-star');

        window.setTimeout(() => {
          this.closeReviewModal();
        }, 5000)
      })
      .catch(err => {
        throw err;
      })
    },

    showModalReview() {
      if (this.review.loaded && !this.review.sent && !this.hasOneLection) {
        this.showModalFromProgress(this.progress);
      }
    },
    showModalFromProgress(percentage) {
      const storageReviews = window.localStorage.getItem('arcux_reviews')
        ? JSON.parse(window.localStorage.getItem('arcux_reviews'))
        : false;

      if (percentage >= 90) {
        if (!storageReviews || (storageReviews && storageReviews[this.course] === 1)) {
          this.$bvModal.show('modalReview');

          this.startCancelCounter(2);
        }
      } else if (percentage >= 50) {
        if (!storageReviews || (storageReviews && !storageReviews[this.course])) {
          this.$bvModal.show('modalReview');

          this.startCancelCounter(1);
        }
      }
    },
    startCancelCounter(stepProgress) {
      this.cancelCounter = 5;

      const storageReviews = window.localStorage.getItem('arcux_reviews')
        ? JSON.parse(window.localStorage.getItem('arcux_reviews'))
        : false;

      if (storageReviews) {
        storageReviews[this.course] = stepProgress;

        window.localStorage.setItem('arcux_reviews', JSON.stringify(storageReviews))
      } else {
        window.localStorage.setItem('arcux_reviews', JSON.stringify({
          [this.course]: stepProgress,
        }));
      }

      this.cancelCounterTimer = window.setInterval(() => {
        if (this.cancelCounter > 0) {
          this.cancelCounter -= 1;
        }
      }, 1000);
    },
    removeReviewsStorage() {
      const storageReviews = window.localStorage.getItem('arcux_reviews')
        ? JSON.parse(window.localStorage.getItem('arcux_reviews'))
        : false;

      if (storageReviews && Object.values(storageReviews).length === 1) {
        window.localStorage.removeItem('arcux_reviews');
      } else if (storageReviews) {
        delete storageReviews[this.course];

        window.localStorage.setItem('arcux_reviews', JSON.stringify(storageReviews));
      }
    },
  },
}
</script>
